/**
 * Service: textVariableApi
 */
angular.module('acme.common.service.textVariablesApi', [
    'acme.common.factory.apiVersion',
    'acme.common.factory.QueryStringBuilder'
])
.service('TextVariablesApiService', ['$http', 'ApiVersionFactory', 'QueryStringBuilderFactory', function($http, ApiVersionFactory, QueryStringBuilderFactory) {

    return {
        service: '',

        init: function(endpoint) {
            this.service = endpoint + '/textvariables/groups';
            this.override.service = endpoint + '/textvariables/overrides';
            return this;
        },
    
       
        list: function(props) {
            var q = '',
            av = new ApiVersionFactory();

            if(props) {
                var qs = new QueryStringBuilderFactory({
                  props: props,
                  fields: {
                    optional: ['sortDirection', 'sortField', 'pageSize', 'page']
                  }
                });
                q = qs.query;
              }

            return $http({
                method: 'get',
                url: av.init({ url: (this.service + q) , version: 'v2' })
            });
        },

        get: function(props) {
            var av = new ApiVersionFactory();

            return $http({
                method: 'get',
                url: av.init({ url: this.service + '/' + props.groupId, version: 'v2' })
            });
        },

        override: {
            service: '',

            list: function(props) {
                var q = '',
                av = new ApiVersionFactory();

                if(props) {
                    var qs = new QueryStringBuilderFactory({
                      props: props,
                      fields: {
                          optional: ['sortDirection', 'sortField', 'pageSize', 'page', 'archived']
                      }
                    });
                    q = qs.query;
                }

                return $http({
                    method: 'get',
                    url: av.init({ url: (this.service  + q), version: 'v2' })
                });
            },

            get: function(props) {
                var av = new ApiVersionFactory();

                return $http({
                    method: 'get',
                    url: av.init({ url: this.service + '/' + props.id, version: 'v2' })
                });
            },

            create: function(props) {
                var q = '',
                av = new ApiVersionFactory();

                return $http({
                    method: 'post',
                    url: av.init({ url: this.service, version: 'v2' }),
                    data: {
                        name: props.name,
                        description: props.description,
                        customText: props.customText
                    }
                });
            },

            update: function(props) {
                var q = '',
                av = new ApiVersionFactory();

                return $http({
                    method: 'put',
                    url: av.init({ url: this.service, version: 'v2' }),
                    data: {
                        id: props.id,
                        name: props.name,
                        description: props.description,
                        customText: props.customText,
                        archived: props.archived
                    }
                });
            },

            delete: function(props) {
                var av = new ApiVersionFactory();

                return $http({
                    method: 'delete',
                    url: av.init({ url: this.service + '/' + props.id, version: 'v2' })
                });
            },

        }
    };
}]);
